import { startCase } from "lodash";
import moment from "moment";
import React from "react";
import { Badge } from "react-bootstrap";
import { getVariantFromStatus } from "../../helpers/ui";
function isDateString(inputStr) {
  const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
  return dateRegex.test(inputStr);
}

const getWordFromAction = (action, isFile) => {
  switch (action) {
    case "create":
      return `created this ${isFile ? "service" : "order"}`;

    case "update":
      return `made the following change`;

    default:
      return "";
  }
};

const getChangeText = (value, change, status) => {
  return (
    <span>
      {change && (
        <span>
          {" "}
          {change}{" "}
          {status ? (
            <Badge
              style={{ fontSize: 10 }}
              variant={getVariantFromStatus(value)}
            >
              {value}
            </Badge>
          ) : (
            <b>
              {isDateString(value)
                ? moment(value).format("MMMM Do YYYY, h:mm a")
                : typeof value !== "object"
                ? value
                : value?.name || value?.title}
            </b>
          )}
        </span>
      )}
    </span>
  );
};

const getBadgeFromAction = (action, className) => {
  let variant = "info";
  let text = "";
  switch (action) {
    case "create":
      text = `Create`;
      variant = "success";
      break;
    case "update":
      text = `Update`;
      variant = "dark";
      break;
    case "status":
      text = `Status Change`;
      variant = "danger";
      break;
    default:
      text = "";
      break;
  }

  return (
    <Badge style={{ fontSize: 14 }} variant={variant} className={className}>
      {text}
    </Badge>
  );
};

const LogItem = ({ log, isFile }) => {
  return (
    <div className="w-100">
      <p style={{ fontSize: 12 }} className="mb-1 mt-2">
        <b>{log?.["name"]}</b> {getWordFromAction("update")} on{" "}
        <span className="text-muted font-weight-bold">
          {moment(log?.["timestamp"]).format("MMMM Do YYYY, h:mm a")}
        </span>
        {log &&
          log.changes.map((l) => (
            <li>
              <b>{startCase(l.fieldName)}</b>
              {l?.fromValue &&
                getChangeText(l?.fromValue, "from", l.fieldName === "status")}
              {l?.toValue &&
                getChangeText(l?.toValue, "to", l.fieldName === "status")}
            </li>
          ))}
      </p>
      <hr className="my-2" />
    </div>
  );
};

export default LogItem;
